<template>
  <div>
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger as-child>
          <Button
            @click="emit('click')"
            class="hover:transition duration-300 ease-in-out bg-transparent text-toolbar-icon"
            :size="props.size ? props.size : 'default'"
            :disabled="props.disabled"
            :class="
              props.active
                ? `bg-primary text-primary-foreground ${props.buttonClass ?? ''}`
                : `hover:bg-secondary hover:text-secondary-foreground ${props.buttonClass ?? ''}`
            "
          >
            <component v-if="!!props.icon" class="size-6" :is="props.icon" />

            <div :class="!props.icon || props.size === 'icon' ? 'ml-0' : 'ml-3'">
              <slot />
            </div>
          </Button>
        </TooltipTrigger>
        <TooltipContent v-if="!!props.tooltip">{{ props.tooltip }}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
</template>

<script lang="ts" setup>
import { LucideProps } from 'lucide-vue-next';
import { FunctionalComponent } from 'vue';
import { ButtonVariants } from './ui/button';

const emit = defineEmits(['click']);

const props = defineProps<{
  // eslint-disable-next-line @typescript-eslint/ban-types
  icon?: FunctionalComponent<LucideProps, {}, any, {}>;
  size?: ButtonVariants['size'];
  tooltip?: string;
  disabled?: boolean;
  buttonClass?: string;
  active?: boolean;
}>();
</script>
